import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelRadio as _vModelRadio, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69eae896"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "radio-element" }
const _hoisted_2 = ["id", "value", "checked"]
const _hoisted_3 = ["for"]


import { useField } from 'vee-validate';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasicRadio',
  props: {
    radiovalue: {},
    id: {},
    name: {},
    label: {},
    checked: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



const { value, handleChange } = useField(props.name, {
  initialValue: props.radiovalue,
  valueProp: props.radiovalue
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", _mergeProps(_ctx.$attrs, {
      id: _ctx.id,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
      type: "radio",
      value: _ctx.radiovalue,
      checked: _ctx.radiovalue === Number(_unref(value)) || _ctx.checked,
      onChange: _cache[1] || (_cache[1] = ($event: any) => (_unref(handleChange)(_ctx.radiovalue)))
    }), null, 16, _hoisted_2), [
      [_vModelRadio, _unref(value)]
    ]),
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: _ctx.id
        }, _toDisplayString(_ctx.label), 9, _hoisted_3))
      : _createCommentVNode("", true)
  ]))
}
}

})